import { React, useEffect, useState, useRef } from 'react';
import * as Yup from 'yup';
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import { useSnackbar } from 'notistack';

// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography, Divider, Button, IconButton } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { startOfMonth, endOfMonth, format } from 'date-fns';

// components
import { useFormik, Form, FormikProvider, isNaN } from 'formik';
import axios from 'axios';
import Moment from 'moment';
import { handleError } from '../../../components/Common/Utils';
import AppCache from '../../../services/AppCache';
import URLS from '../../../services/urls.service';

import Iconify from '../../../components/Iconify';

import ModalPopUp from '../../../components/Common/ModalPopUp';
import Page from '../../../components/Page';
import OAMasterDetails from '../../../components/SidebarMenuComponents/OAComponent/OAMasterDetails';
import StatusServicePage from '../../../components/SidebarMenuComponents/ServiceComponent/StatusServicePage';


// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ServiceDetailsPage() {
    const location = useLocation();
    const navigate = useNavigate(); // Hook for navigation
    const [pageSize, setPageSize] = useState(25);
    const [pageSize1, setPageSize1] = useState(25);
    const [pageSize2, setPageSize2] = useState(25);
    const [pageSize3, setPageSize3] = useState(25);
    const [pageSize4, setPageSize4] = useState(25);
    const [pageSize5, setPageSize5] = useState(25);
    const [pageSize6, setPageSize6] = useState(25);
    const [isLoading, setIsLoading] = useState();

    const loadData = location.state?.loadData || [];

    const { openServiceTab = false, fromEdit = false, } = location.state || {};

    console.log("loadData:", loadData, "openServiceTab", openServiceTab, "fromEdit", fromEdit, "editServiceData");

    const trackerDetailsColumn = [

        { field: 'TotalServiceMinutes', headerName: 'Duration', width: 80 },
        { field: 'ContactPerson', headerName: 'Executive' },
        { field: 'ServiceProvided', headerName: 'Service Remarks', width: 400 },

    ];
    const RecurringDropdown = [
        { Id: true, value: 'Yes' },
        { Id: false, value: 'No' },
    ];
    const activityTypeService = [
        { field: 'SrNo', headerName: 'Sr.No', width: 80 },
        { field: 'Name', headerName: 'Name', flex: 0.5 },
        { field: 'Description', headerName: 'Description', flex: 1 }
    ];
    const [editData, setEditData] = useState([]);

    const fillInstallationNavigateClick = (serviceProvided) => {
        const serviceProvidedText = String(serviceProvided); // Ensure it's a string

        // Extract number at the end of the string
        const match = serviceProvidedText.match(/(\d+)$/);
        const installationReportId = match ? parseInt(match[1], 10) : null;

        const payload = { InstallationReportQuestionnairesMasterId: installationReportId };
        URLS.fillInstallationReportFilterData(payload)
            .then((response) => {
                const jsonDataString = JSON.stringify(response?.data);

                const modifiedData = JSON.parse(jsonDataString);
                console.log("modifiedData", modifiedData)
                setEditData(modifiedData);
                navigate('/dashboard/fillinstallationreportdetailspage', { state: { fillInstallation: modifiedData } })

            })
            .catch(error => {
                // On error
                console.error("")

            });
    }
    const showPreviousServiceColumn = [
        { field: "ServiceStartTime", headerName: "Date", flex: 0.3 },
        { field: "TotalServiceMinutes", headerName: "Duration", flex: 0.2 },
        { field: "ExecutiveName", headerName: "Executive", flex: 0.3 },
        {
            field: "ServiceProvided",
            headerName: "Service Remarks",
            flex: 1,
            renderCell: (params) => {
                const serviceProvided = params.row.ServiceProvided || "";
                const fileUrls = params.row.FileUrl || []; // Ensure it's always an array
                const fileNames = params.row.FileKeys || []; // Ensure it's always an array

                const downloadFile = (key) => {
                    const encodedKey = encodeURIComponent(key); // Encode special characters
                    URLS.downloadServiceFile(encodedKey, { responseType: "blob" }) // API call to get the file
                        .then((response) => {
                            const requestUrl = response.request.responseURL; // Get the actual file URL

                            const link = document.createElement("a");
                            link.href = requestUrl; // Directly use the response URL
                            link.setAttribute("download", key); // Set the filename
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);

                            console.log("File downloaded from:", requestUrl); // Log request URL for debugging
                        })
                        .catch(error => {
                            enqueueSnackbar("File not found.", { variant: "error" });
                        });
                };

                const matchText = "Installation report against Issue generated. please fill details online";
                const isInstallationReport = serviceProvided.includes(matchText);

                return (
                    <div>
                        {isInstallationReport ? (
                            <a
                                href="#"
                                style={{
                                    color: "blue",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                }}
                                onClick={() => fillInstallationNavigateClick(serviceProvided)}

                            >
                                {matchText}
                            </a>
                        ) : (
                            <div dangerouslySetInnerHTML={{ __html: serviceProvided }} />
                        )}
                        {fileUrls.map((fileUrl, index) => {
                            const extractedFileName = fileUrl.split("/").pop().split("?")[0];
                            const displayFileName = params.row.FileNames?.[index];

                            return (
                                <a
                                    key={index}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        downloadFile(fileNames[index]); // Use full key for downloading
                                    }}
                                    style={{
                                        color: "blue",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                        display: "block",
                                    }}
                                    href="#"
                                >
                                    {displayFileName}
                                </a>
                            );
                        })}

                    </div>
                );
            },
        },

    ];

    const issueAllocationHistoryColumn = [
        { field: 'AllocatedDate', headerName: 'Allocated Date', flex: 0.4 },
        { field: 'AllocatedByName', headerName: 'Allocated By', flex: 0.3 },
        { field: 'OwnedByName', headerName: 'Owned By', flex: 0.3 },
        { field: 'AllocationReason', headerName: 'Allocation Reason', flex: 0.3 },
        { field: 'LastAppointmentDate', headerName: 'Last Appointment Date', flex: 0.4 },
        { field: 'CurrentAppointmentDate', headerName: 'Current Appointment Date', flex: 0.4 },
        { field: 'Activity', headerName: 'Activity', flex: 0.2 },
        { field: 'EstimatedTime', headerName: 'Estimated Time	', flex: 0.4 },
        { field: 'Status', headerName: 'Status', flex: 0.3 },
        { field: 'LastEditDate', headerName: 'Last Edited Date', flex: 0.4 },
        { field: 'IsTaskCompleted', headerName: 'Task Completed', flex: 0.4 },

    ];
    const contactColumn = [
        { field: 'ExecutiveName', headerName: 'Executive Name', flex: 1 },
        { field: 'MobileNumber', headerName: 'Contact Details', flex: 1 },
        { field: 'Email', headerName: 'Email-Id', flex: 1 }
    ];
    const observationHistoryColumn = [
        { field: 'InsertedBy', headerName: 'Observation By', flex: 0.8 },
        {
            field: 'RCADate', headerName: 'Date', flex: 0.8, valueFormatter: (params) =>
                params.value ? Moment(params.value).format('DD/MMM/YYYY') : '',
        },
        { field: 'ReasonType', headerName: 'Reason Type', flex: 1 },

        { field: 'Reason', headerName: 'Reason', flex: 1 },
        { field: 'Solution', headerName: 'Solution', flex: 1 },
        { field: 'IsRecurring', headerName: 'Recurring', flex: 0.5 },
        { field: 'Occurrence', headerName: 'Occurrence', flex: 1 },
        { field: 'Type', headerName: 'Type', flex: 1 },

        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            width: 50,
            renderCell: (params) => {
                const row = params.row;
                if (
                    row.Type?.toLowerCase().trim() === 'observation' &&
                    row.CreatedById === userId
                ) {
                    return (
                        <IconButton onClick={(event) => handleClick(event, params)}>
                            <Iconify icon="ic:outline-edit" width="20px" height="20px" color="primary.main" />
                        </IconButton>
                    );
                }
                return null;
            },
        }

    ];

    const obsEntryHistoryColumn = [
        { field: 'InsertedBy', headerName: 'Observation By', flex: 0.8 },
        {
            field: 'RCADate', headerName: 'Date', flex: 0.8, valueFormatter: (params) =>
                params.value ? Moment(params.value).format('DD/MMM/YYYY') : '',
        },
        { field: 'ReasonType', headerName: 'Reason Type', flex: 1 },

        { field: 'Reason', headerName: 'Reason', flex: 1 },
        { field: 'Solution', headerName: 'Solution', flex: 1 },
        { field: 'IsRecurring', headerName: 'Recurring', flex: 0.5 },
        { field: 'Occurrence', headerName: 'Occurrence', flex: 1 },
        { field: 'Type', headerName: 'Type', flex: 1 },

        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            width: 50,
            renderCell: (params) => {
                const row = params.row;
                if (
                    row.Type?.toLowerCase().trim() === 'observation' &&
                    row.CreatedById === userId
                ) {
                    return (
                        <IconButton onClick={(event) => handleEntryObsClick(event, params)}>
                            <Iconify icon="ic:outline-edit" width="20px" height="20px" color="primary.main" />
                        </IconButton>
                    );
                }
                return null;
            },
        }

    ];

    const observationRCAHistoryColumn = [
        { field: 'InsertedBy', headerName: 'Observation By', flex: 1 },
        {
            field: 'RCADate', headerName: 'Date', flex: 1, valueFormatter: (params) =>
                params.value ? Moment(params.value).format('DD/MMM/YYYY') : '',
        },
        { field: 'ReasonType', headerName: 'Reason Type', flex: 1 },

        { field: 'Reason', headerName: 'Reason', flex: 1 },
        { field: 'Solution', headerName: 'Solution', flex: 1 },
        { field: 'IsRecurring', headerName: 'Recurring', flex: 1 },
        { field: 'Occurrence', headerName: 'Occurrence', flex: 1 },

    ];
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();

    const userId = CurrentLoggedInUser.ExecutiveId;

    const { enqueueSnackbar } = useSnackbar();
    const [openModalForCancel, setOpenModalCancel] = useState(false);

    const [openModalForSaveStatus, setOpenModalForSaveStatus] = useState(false);
    const [openModalForSaveAllocation, setOpenModalForSaveAllocation] = useState(false);
    const [openModalForSaveService, setOpenModalForSaveService] = useState(false);
    const [openModalForDeleteService, setOpenModalForDeleteService] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    const [value, setValue] = useState(0);
    const [hide, setHide] = useState(false);
    const [statusPageData, setStatusPageData] = useState([]);

    // Status Page
    const [editRCAData, setEditRCAData] = useState([]);
    const [subStatus, setSubStatus] = useState("");
    const [selectedSubStatus, setSelectedSubStatus] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openTrcakerDetailsModal, setOpenTrcakerDetailsModal] = useState(false);
    const [statusRemark, setStatusRemark] = useState("");
    const [clientRemark, setClientRemark] = useState("");
    const [siteRemark, setSiteRemark] = useState("");
    const [clientSiteRemark, setClientSiteRemark] = useState("");
    const [trackerDetailsData, setTrackerDetailsData] = useState([]);
    const [deliveryTime, setDeliveryTime] = useState("");
    const [isCheck, setIsCheck] = useState(false);
    console.log("statusPageData", statusPageData, statusPageData.SubStatusId, statusPageData.IssueRemark)
    // Issue Allocation page
    const [executive, setExecutive] = useState(userId || "");
    const [selectedExecutive, setSelectedExecutive] = useState([]);
    const [project, setProject] = useState("");
    const [remarkIssueAllocation, setRemarkIssueAllocation] = useState("");
    const [selectedProject, setSelectedProject] = useState([]);
    const [openAppointmentModal, setOpenAppointmentModal] = useState(false);
    const [activity, setActivity] = useState("");
    const [selectedActivity, setSelectedActivity] = useState([]);
    const [estimatedTime, setEstimatedTime] = useState("");
    const [appointmentDateTime, setAppointmentDateTime] = useState("");
    const [appointmentTime, setAppointmentTime] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [availableSlotsData, setAvailableSlotsData] = useState([]);
    const [tentativeSupport, setTentativeSupport] = useState("");
    const [showTentativeSupport, setShowTentativeSupport] = useState(false);
    const [questionnaireModal, setQuestionnaireModal] = useState(false);
    const [questionnaire, setQuestionnaire] = useState("");
    const [selectedQuestionnaire, setSelectedQuestionnaire] = useState([]);
    const [questionnaireTxt, setQuestionnaireTxt] = useState("");
    const [allocationReason, setAllocationReason] = useState("");
    const [selectedObservationEditData, setSelectedObservationEditData] = useState("");

    const [selectedAllocationReason, setSelectedAllocationReason] = useState([]);
    const [observationOpenModal, setObservationOpenModal] = useState(false);
    const [observationReasonDdl, setObservationReasonDdl] = useState("");
    const [selectedObservationReasonDdl, setSelectedObservationReasonDdl] = useState([]);
    const [observationReasonTxt, setObservationReasonTxt] = useState("");
    const [observationsolutionTxt, setObservationSolutionTxt] = useState("");
    const [observationRecurring, setObservationRecurring] = useState(true);
    const [observationOccurrence, setObservationOccurrence] = useState("");
    const [observationRcaDate, setObservationRcaDate] = useState(format(new Date(), "dd-MMM-yyyy"));
    const [observationEditData, setObservationEditData] = useState([]);

    // Service entry page 
    const [serviceDate, setServiceDate] = useState(null);
    const [contactPerson, setContactPerson] = useState("");
    const [selectedContactPerson, setSelectedContactPerson] = useState([]);
    const [contactDetails, setContactDetails] = useState("");
    const [serviceType, setServiceType] = useState(27 || "");
    const [selectedServiceType, setSelectedServiceType] = useState([]);
    const [timeType, setTimeType] = useState("from-to");
    const [serviceEntryRemark, setServiceEntryRemark] = useState("");
    const [activityTypeModal, setActivityOpenModal] = useState(false);
    const [activityTypeServiceData, setActivityTypeServiceData] = useState([]);
    const [selectedServiceActivity, setSelectedServiceActivity] = useState([]);

    const [reasonOpenModal, setReasonOpenModal] = useState(false);
    const [reasonDdl, setReasonDdl] = useState("");
    const [selectedReasonDdl, setSelectedReasonDdl] = useState([]);
    const [reasonTxt, setReasonTxt] = useState("");
    const [solution, setSolution] = useState("");
    const [recurring, setRecurring] = useState(true);
    const [occurrence, setOccurrence] = useState("");
    const [rcaDate, setRcaDate] = useState(format(new Date(), "dd-MMM-yyyy"));
    const { IsRCA } = statusPageData
    const [requestFile, setRequestFile] = useState([]);
    const [error, setError] = useState("");
    const fileInputRef = useRef(null);

    const [entryObsOpen, setEntryObsOpen] = useState(false);
    const [entryObsHistoryOpen, setEntryObsHistoryOpen] = useState(false);

    const [entryObsDate, setEntryObsDate] = useState(format(new Date(), "dd-MMM-yyyy"));
    const [entryObsReason, setEntryObsReason] = useState("");
    const [entryObsReasonDdl, setEntryObsReasonDdl] = useState([]);

    const [entryObsReasonTxt, setEntryObsReasonTxt] = useState("");
    const [entryObsSolutionTxt, setEntryObsSolutionTxt] = useState("");
    const [entryObsOccurrence, setEntryObsOccurrence] = useState("");
    const [entryObsRecurring, setEntryObsRecurring] = useState("");
    const [entryObsData, setEntryObsData] = useState("");
    const [entryObsEditData, setEntryObsEditData] = useState([]);

    // show previous service
    const [showPreviousServiceModal, setShowPreviousServiceOpenModal] = useState(false);
    const [showPreviousServiceData, setShowPreviousServiceData] = useState([]);

    // issue allocation history
    const [issueAllocationHistoryOpenModal, setIssueAllocationHistoryOpenModal] = useState(false);
    const [issueAllocationHistoryData, setIssueAllocationHistoryData] = useState([]);
    const [observationHistoryModal, setObservationHistoryModal] = useState(false);
    const [observationHistoryOpenModal, setObservationHistoryOpenModal] = useState(false);
    const [observationAddModal, setObservationAddModal] = useState(false);
    const [observationHistoryData, setObservationHistoryData] = useState([]);
    const [tabObservationHistoryModal, setTabObservationHistoryModal] = useState(false);

    const [contactOpenModal, setContactOpenModal] = useState(false);
    const [contactData, setContactData] = useState([]);

    const [disableDownloadBtn, setDisableDownloadBtn] = useState(false);

    const [ServiceEntries, setServiceEntries] = useState([
        { fromTime: "", toTime: "", startMin: "", minute: "", serviceActivity: "", serviceRemark: "", isShowToClient: false }
    ]);
    const [isObservationSaved, setIsObservationSaved] = useState(false);
    const [defaultTime, setDefaultTime] = useState("00:00");

    console.log("edit>>>>>>>>>>>>>>>>>", statusPageData, loadData, editRCAData)
    const [showServiceEntry, setShowServiceEntry] = useState(openServiceTab || false);
    const [isShowToClient, setIsShowToClient] = useState(false);

    const [expandedAccordion, setExpandedAccordion] = useState(0); // Default: open first

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleObservationClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAddNew = () => {
        handleClose();
        setObservationAddModal(true);
    };

    const handleAddNewCloseModal = () => {
        console.log("click>>>>>")
        setObservationAddModal(false);
        setEntryObsReason("");
        setEntryObsReasonTxt("");
        setEntryObsSolutionTxt("");
        setEntryObsRecurring(true);
        setEntryObsOccurrence("");
        setEntryObsDate((new Date()));
    };
    const handleHistory = () => {
        handleClose();
        setObservationHistoryOpenModal(true);
        URLS.getIssueRcaAndObservationData({ IssueId: loadData.Id })
            .then((response) => {
                setEntryObsEditData(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

        // your logic here
    };
    const handleHistoryClick = () => {
        setObservationHistoryOpenModal(false);

    };
    const handleTabObservationHistoryModal = () => {
        setTabObservationHistoryModal(true);
        URLS.getIssueRcaAndObservationData({ IssueId: loadData.Id })
            .then((response) => {
                setEntryObsEditData(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    }
    const handleTabObservationHistoryCloseModal = () => {
        setTabObservationHistoryModal(false);

    }

    const handleObsEntryDate = (newValue) => {
        if (newValue) {
            setEntryObsDate(format(newValue, "dd-MMM-yyyy"));
        }
    };
    const handleObsEntrySolution = (e) => {
        setEntryObsSolutionTxt(e.target.value)
    }
    const handleObsEntryOccurrence = (e) => {
        setEntryObsOccurrence(e.target.value)
    };
    const handleObsEntryReasonTxt = (e) => {
        setEntryObsReasonTxt(e.target.value)
    };

    const handleObsEntryRecurring = (id) => {
        setEntryObsRecurring(id);
    };
    const handleObsEntryReasonDdl = (newValue) => {
        setEntryObsReason(newValue?.id || "");
    };
    const handleObsEntryReset = () => {
        setEntryObsReason(entryObsData?.ReasonId || "");
        setEntryObsReasonTxt(entryObsData?.Reason || "");
        setEntryObsSolutionTxt(entryObsData?.Solution || "");
        setEntryObsRecurring(entryObsData?.IsRecurring || true);
        setEntryObsOccurrence(entryObsData?.Occurrence || "");
        setEntryObsDate(entryObsData?.RCADate || (new Date()));
    };
    const handleObsEntrySave = () => {
        console.log("save")
        const payload = {
            "IssueRCAId": 0,
            "LoginId": userId,
            "IssueId": loadData.Id || "",
            "ReasonId": entryObsReason || "",
            "Reason": entryObsReasonTxt || "",
            "Solution": entryObsSolutionTxt || "",
            "IsRecurring": entryObsRecurring,
            "Occurance": entryObsOccurrence || "",
            "RCADate": entryObsDate || "",
            "ObservationId": entryObsData?.Id || 0
        }

        console.log("Observation RCA payload", payload, recurring)
        URLS.updateIssueObservation(payload)
            .then((response) => {
                if (response.status === 200) {
                    setIsObservationSaved(true);
                    enqueueSnackbar("Observation Saved Successfully. ", { variant: 'success' });
                    console.log("response.data.IssueRCAId", response.data.IssueRCAId, response.data)
                    URLS.getIssueRcaAndObservationData({ IssueId: loadData.Id })
                        .then((response) => {
                            setEntryObsEditData(Array.isArray(response.data) ? response.data : []);

                        })
                        .catch(error => {
                            // On error
                            console.log(" Error ");
                        });

                    setObservationAddModal(false);
                }
            }).catch(error => {
                enqueueSnackbar("Record not saved. ", { variant: 'error' });

                console.log(" Error ");

            })
    }
    const handleEntryObsClick = (event, cellValues) => {
        event.stopPropagation();

        const row = cellValues.row;
        setEntryObsData(row);
        if (row.Type?.toLowerCase().trim() === 'observation') {
            // Prefill fields
            setEntryObsReasonTxt(row.Reason || '');
            setEntryObsReason(row.ReasonId || '');
            setEntryObsSolutionTxt(row.Solution || '');
            setEntryObsOccurrence(row.Occurrence || '');
            setEntryObsRecurring(row.IsRecurring ?? true);
            setEntryObsDate(row.RCADate ? new Date(row.RCADate) : null);

            // Close current modal first
            setObservationHistoryOpenModal(false);
            // Fetch data and open edit modal
            URLS.getIssueRcaAndObservationData({ IssueId: row.IssueId })
                .then((response) => {
                    setEntryObsEditData(response.data);
                    setObservationAddModal(true);

                })
                .catch(error => {
                    console.log("Error fetching observation history data:", error);
                });
        }
    };
    const clearObservationFields = () => {
        setObservationReasonDdl("");
        setObservationReasonTxt("");
        setObservationSolutionTxt("");
        setObservationRecurring(true);
        setObservationOccurrence("");
        setObservationRcaDate(new Date());
        setObservationAddModal(false);
        setObservationOpenModal(false);
        setObservationHistoryModal(false);
    };
    const handleShowServiceEntry = () => {
        clearObservationFields();
        setShowServiceEntry(true);
    };

    const handleShowStatusIssue = () => {
        clearObservationFields();
        setShowServiceEntry(false);

    };

    const handleChangeValue = (event, newValue) => {
        setValue(newValue);
    };
    const handleShow = () => {
        setHide(false)
    };
    // Status page

    const handleSubStatus = (newValue) => {
        setSubStatus(newValue?.Id || "");
    };
    const handleClientRemark = (e) => {
        setClientRemark(e.target.value)
    };
    const handleSiteRemark = (e) => {
        setSiteRemark(e.target.value)
    };

    const handleClientSiteRemark = (e) => {
        setClientSiteRemark(e.target.value)
    };
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const handleCloseTrackerDetailsModal = () => {
        setOpenTrcakerDetailsModal(false);
    };
    const handleDeliveryTime = (e) => {
        setDeliveryTime(e.target.value)
    };
    const handelCancelClick = () => {
        setOpenModalCancel(true);
    };
    const handelOpenClick = () => {
        setOpenModal(true);
    };
    const handleObservationModal = () => {
        setObservationOpenModal(true);
        handleClose();

    }
    const handleObservationCloseModal = () => {
        setObservationOpenModal(false);
        setObservationReasonDdl("");
        setObservationReasonTxt("");
        setObservationSolutionTxt("");
        setObservationRecurring(true);
        setObservationOccurrence("");
        setObservationRcaDate((new Date()));
    };
    const handleObservationReasonDdl = (newValue) => {
        setObservationReasonDdl(newValue?.id || "");
    };
    const handleObservationReason = (e) => {
        setObservationReasonTxt(e.target.value)
    };
    const handleObservationSolution = (e) => {
        setObservationSolutionTxt(e.target.value)
    };

    const handleObservationRecurring = (id) => {
        setObservationRecurring(id);
    };
    const handleObservationOccurrence = (e) => {
        setObservationOccurrence(e.target.value)
    };
    const handleObservationRcaDate = (newValue) => {
        if (newValue) {
            setObservationRcaDate(format(newValue, "dd-MMM-yyyy"));
        }
    };

    console.log("observation >>>>>>>>>>>>>>>>>>>>>>>", selectedObservationEditData)

    const handleObservationRCASave = () => {
        console.log("save")
        const payload = {
            "IssueRCAId": 0,
            "LoginId": userId,
            "IssueId": loadData.Id || "",
            "ReasonId": observationReasonDdl || "",
            "Reason": observationReasonTxt || "",
            "Solution": observationsolutionTxt || "",
            "IsRecurring": observationRecurring,
            "Occurance": observationOccurrence || "",
            "RCADate": observationRcaDate || "",
            "ObservationId": selectedObservationEditData.Id || 0
        }

        console.log("Observation RCA payload", payload, recurring)
        URLS.updateIssueObservation(payload)
            .then((response) => {
                if (response.status === 200) {
                    setIsObservationSaved(true);
                    enqueueSnackbar("Observation Saved Successfully. ", { variant: 'success' });
                    console.log("response.data.IssueRCAId", response.data.IssueRCAId, response.data)
                    URLS.getIssueRcaAndObservationData({ IssueId: loadData.Id })
                        .then((response) => {
                            setObservationEditData(Array.isArray(response.data) ? response.data : []);

                        })
                        .catch(error => {
                            // On error
                            console.log(" Error ");
                        });


                    setObservationOpenModal(false);
                }
            }).catch(error => {
                enqueueSnackbar("Record not saved. ", { variant: 'error' });

                console.log(" Error ");

            })
    }
    const handleObservationRCAReset = () => {
        setObservationReasonDdl(selectedObservationEditData?.ReasonId || "");
        setObservationReasonTxt(selectedObservationEditData?.Reason || "");
        setObservationSolutionTxt(selectedObservationEditData?.Solution || "");
        setObservationRecurring(selectedObservationEditData?.IsRecurring || true);
        setObservationOccurrence(selectedObservationEditData?.Occurrence || "");
        setObservationRcaDate(selectedObservationEditData?.RCADate || (new Date()));
    };
    const handeltrackerDetailsOpenClick = () => {
        setOpenTrcakerDetailsModal(true);
    };
    const handleStatusCheckbox = (event) => {
        setIsCheck(event.target.checked);
    };
    const handelReasonOpenClick = () => {
        setReasonOpenModal(true);
        URLS.loadIssueRCAData({ IssueRCAId: statusPageData.IssueRCAId })
            .then((response) => {
                const data = response.data[0];
                setEditRCAData(data);
                setReasonDdl(data?.ReasonId || "");
                setReasonTxt(data?.Reason || "");
                setSolution(data?.Solution || "");
                setRecurring(data?.IsRecurring ?? true);
                setOccurrence(data?.Occurrence || "");
                setRcaDate(data?.RCADate || format(new Date()), "dd-MMM-yyyy");
            })
            .catch(error => {
                console.log("Error in loadIssueRCAData:", error);
            });
    };
    const handleStatusReset = () => {
        setDeliveryTime('');
        setIsCheck(false);
        setSubStatus(statusPageData.SubStatusId || "")
    }
    const handleQuestionnaireOpenClick = () => {
        setQuestionnaireModal(true);
        setOpenAppointmentModal(false);
        URLS.getAppointmentDateQuestionnaire()
            .then((response) => {
                const data = response.data[0];
                setQuestionnaireTxt(response.data[0].Questionnaire)
                console.log("data>>>>>>>>>>>>>>>>>>", data, response.data[0].Questionnaire)
                setSelectedQuestionnaire(response.data[0].DataValues)
            })
            .catch(error => {
                console.log("Error in loadIssueRCAData:", error);
            });
    }
    const handelQuestionnaireCancelClick = () => {
        setQuestionnaireModal(false);
    };
    const handleQuestionnaire = (event) => {
        setQuestionnaire(event.target.value)
    }
    const handleIssueAllocationRemark = (newValue) => {
        setRemarkIssueAllocation(newValue);
    }
    const handelReasonCancelClick = () => {
        setReasonOpenModal(false);
    };
    const handleReasonDdl = (newValue) => {
        setReasonDdl(newValue?.id || "");
    };
    const handleReason = (e) => {
        setReasonTxt(e.target.value)
    };
    const handleSolution = (e) => {
        setSolution(e.target.value)
    };
    const handleRecurring = (id) => {
        setRecurring(id);
    };
    const handleOccurrence = (e) => {
        setOccurrence(e.target.value)
    };
    const handleRcaDate = (newValue) => {
        if (newValue) {
            setRcaDate(format(newValue, "dd-MMM-yyyy"));  // Store in "05-Feb-2025" format
        }
    };

    const handleRCASave = () => {
        const payload = {
            "IssueRCAId": statusPageData.IssueRCAId || "",
            "LoginId": userId,
            "IssueId": loadData.Id || "",
            "ReasonId": reasonDdl || 0,
            "Reason": reasonTxt || "",
            "Solution": solution || "",
            "IsRecurring": recurring,
            "Occurance": occurrence || "",
            "RCADate": rcaDate
        }

        console.log("RCA payload", payload, recurring)
        URLS.updateIssueRcaData(payload)
            .then((response) => {
                if (response.status === 200) {
                    enqueueSnackbar("RCA Updated Successfully. ", { variant: 'success' });
                    console.log("response.data.IssueRCAId", response.data.IssueRCAId, response.data)
                    setReasonOpenModal(false);

                }
            }).catch(error => {
                enqueueSnackbar("Record not saved. ", { variant: 'error' });

                console.log(" Error ");

            })
    };
    const handleRCAReset = () => {
        setReasonDdl("");
        setReasonTxt("");
        setSolution("");
        setRecurring(true);
        setOccurrence("");
        setRcaDate(new Date());
    };
    const handleStatusRemarkSave = () => {
        setOpenModal(false);
        const payload = {
            "SiteId": loadData.SiteId || "",
            "ClientId": loadData.ClientId || "",
            "SiteRemark": siteRemark || "",
            "ClientRemark": clientRemark || "",
            "CommonRemark": clientSiteRemark || ""
        }

        URLS.updateRemark(payload)
            .then((response) => {
                enqueueSnackbar("Remark Saved Successfully. ", { variant: 'success' });


            }).catch(error => {
                enqueueSnackbar("Remark Not Saved. ", { variant: 'error' });

                console.log(" Error ");

            })
    }
    const handleStatusSave = () => {
        const payload = {
            "IssueId": loadData.Id || "",
            "SubStatusId": subStatus || "",
            "IsCallListIssue": isCheck || false,
            "IssueDate": loadData.Date,
            "IssueOwnedBy": loadData.IssueOwnedById || 0,
            "SiteId": loadData.SiteId,
            "ClientId": loadData.ClientId,
            "Remarks": loadData.Remarks || "",
            "ClientName": loadData.ClientName || "",
            "SiteName": loadData.Site || "",
            "DeliveryTime": deliveryTime || 0
        }

        URLS.updateServiceStatus(payload)
            .then((response) => {
                if (response.status === 200) {
                    setDeliveryTime("");
                    setIsCheck(false);
                }
                enqueueSnackbar("Saved Status Successfully. ", { variant: 'success' });
            }).catch(error => {
                enqueueSnackbar("Record not saved. ", { variant: 'error' });

                console.log(" Error ");

            })
    }
    const handleSaveStatusConfirm = (value) => {
        if (value) {
            handleStatusSave(); // Your existing save logic
        }
        setOpenModalForSaveStatus(false);
    };
    const handleSaveStatusClick = () => {
        setOpenModalForSaveStatus(true);
    };

    // Issue allocation

    const hnadleIssueAllocationReset = () => {
        setExecutive(loadData?.IssueOwnedById || "");
        setProject(loadData?.ProjectVersionId || "");
        setRemarkIssueAllocation("");
        setActivity("");
        setEstimatedTime("");
        setAllocationReason("")
    }
    const handleExecutive = (newValue) => {
        setExecutive(newValue)
    };
    const handleProject = (newValue) => {
        setProject(newValue?.ProjectVersionId || "");
    };
    const handleAppointmentOpenModal = () => {
        setOpenAppointmentModal(true);
    }
    const handleAppointemntCloseModal = () => {
        setOpenAppointmentModal(false);
        setError("");
    };
    const handleActivity = (newValue) => {
        setActivity(newValue?.Id || "")

    };
    const handleEstimatedTime = (e) => {
        setEstimatedTime(e.target.value)
    };
    const handleAppointmentDateTime = (newDate) => {
        setAppointmentDateTime(newDate); // Store as Date object
        if (newDate) setError("");
        if (!newDate && appointmentTime) {
            handleQuestionnaireOpenClick();
        }
    };
    const handleAppointmentTime = (e) => {
        setAppointmentTime(e.target.value); // Time input uses "HH:mm"
        if (e.target.value) setError("");
        if (!appointmentDateTime && setAppointmentTime) {
            handleQuestionnaireOpenClick();
        }
    };
    const handleAllocationReason = (newValue) => {
        setAllocationReason(newValue?.Id || "");
        setObservationReasonDdl("");
        setObservationReasonTxt("");
        setObservationSolutionTxt("");
        setObservationOccurrence("");
        setObservationRecurring(true);
        const formattedDate = format(new Date(), "dd-MMM-yyyy");
        setObservationRcaDate(formattedDate);
    };
    console.log("newValue", selectedAllocationReason, allocationReason)

    const handleTentativeSupport = () => {
        URLS.getTentativeSupport()
            .then((response) => {

                setTentativeSupport(response.data || [])
                setExecutive(response.data);
                setOpenAppointmentModal(false);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    }



    console.log("setSelectedDate", selectedDate)
    const handleAppointmentSave = () => {
        if (!appointmentDateTime) {
            setError("Please select an appointment Date.");
            return;
        }
        if (!appointmentTime) {
            setError("Please select an appointment time.");
            return;
        }
        const selectedTime = Moment(appointmentTime, "hh:mm A");
        const selectedHour = selectedTime.hour();
        const selectedMinute = selectedTime.minute();

        const isValidTime =
            (selectedHour > 8 || (selectedHour === 8 && selectedMinute >= 30)) &&
            selectedHour < 18;

        if (!isValidTime) {
            setError("The appointment time is not in office hours.");
            return;
        }
        const formattedDate = Moment(appointmentDateTime).format("DD-MMM-YYYY"); // Extract date
        const formattedTime = Moment(appointmentTime, "hh:mm A").format("hh:mm A"); // Format time

        const mergedDateTime = `${formattedDate} ${formattedTime}`;
        const payload = {
            "AppointmentDateTime": mergedDateTime,
            "ExecutiveId": executive,
            "ClientId": loadData.ClientId || "",
            "IssueCategoryID": loadData.IssueCategory,
        };

        URLS.getAvailableSlots(payload)
            .then((response) => {
                const data = response.data;

                if (typeof data === "string") {
                    setOpenAppointmentModal(false);
                    setShowTentativeSupport(false);
                } else if (Array.isArray(data) && data.length > 0 && typeof data[0] === "object") {
                    setAvailableSlotsData(data);
                    setShowTentativeSupport(true);
                }
            })
            .catch(error => {
                console.log("Error fetching available slots", error);
            });
        setSelectedDate(mergedDateTime); // Save valid date

    }

    const availableSlotsDataColumn =
        availableSlotsData?.length > 0
            ? Object.keys(availableSlotsData[0]).map((key) => ({
                field: key,
                headerName: key === "SlotDate" ? "Date" : key.replace("_", "").replace("_", ":"),
                width: key === "SlotDate" ? 150 : 80,
                headerAlign: "center",
                align: "center",
            }))
            : [];

    const fetchAndSetEndTime = (date) => {
        URLS.getFilteredServicEntrySectionD({
            StartTime: Moment(date).format("DD-MMM-YYYY"),
            UserID: userId
        })
            .then((response) => {
                if (Array.isArray(response.data) && response.data.length > 0) {
                    const endTime = Moment(response.data[0].StartDate)
                        .add(response.data[0].TotalTimeSpentInMin, 'minutes')
                        .format('HH:mm');

                    setDefaultTime(endTime);
                    setServiceEntries(prev =>
                        prev.map((entry, i) =>
                            i === 0 ? { ...entry, fromTime: endTime, startMin: endTime, toTime: "" } : entry
                        )
                    );
                } else {
                    setDefaultTime("00:00");
                    setServiceEntries(prev =>
                        prev.map((entry, i) =>
                            i === 0 ? { ...entry, fromTime: "00:00", startMin: "00:00", toTime: "" } : entry
                        )
                    );
                }
            })
            .catch((error) => console.log("error", error));
    };

    console.log("appointmentDateTime", appointmentDateTime, appointmentTime, availableSlotsData)

    const validateIssueAllocation = () => {
        if (!activity) {
            enqueueSnackbar("Please select Activity Type ");
            return false;;
        }
        if (!allocationReason) {
            enqueueSnackbar("Please select Allocation Reason ");
            return false;;
        }

        const selectedReason = selectedAllocationReason.find(item => item.Id === allocationReason);
        if (selectedReason?.ExpectedTime === 0) {
            const isObservationPartiallyFilled =
                (observationReasonDdl ?? "") !== "" ||
                observationReasonTxt.trim() !== "" ||
                observationsolutionTxt.trim() !== "" ||
                observationOccurrence.trim() !== "" ||
                observationRcaDate !== null ||
                observationRecurring !== null;

            if (isObservationPartiallyFilled && !isObservationSaved) {
                enqueueSnackbar("Please save the Observation data before allocating the issue.");
                return false;
            }
        }

        if (executive === 6845 && new Date(appointmentDateTime).toDateString() === new Date().toDateString()) {
            enqueueSnackbar("Cannot allocate issue on SOFTWARE SUPPORT for today.");
            return false;
        }
        const createdDate = loadData.CreatedDate && !isNaN(new Date(loadData.CreatedDate))
            ? new Date(loadData.CreatedDate).toLocaleDateString("en-CA")  // Fix timezone shift
            : null;

        // Convert appointmentDateTime to YYYY-MM-DD format
        let appointmentDate = null;

        if (appointmentDateTime !== "Set Appointment" && appointmentDateTime) {
            appointmentDate = new Date(appointmentDateTime).toLocaleDateString("en-CA");
        }

        console.log("Created Date:", createdDate);
        console.log("Appointment Date:", appointmentDate);

        if (appointmentDate && createdDate && appointmentDate === createdDate) {
            enqueueSnackbar("Issue creation date and appointment date must be different.");
            return false;
        }
        return true;
    }

    const handleIssueAllocationSave = () => {

        const payload = {
            "IssueId": loadData.Id || 0,
            "IssueownedBy": executive || loadData.IssueownedBy,
            "ProjectVersionId": project || loadData.ProjectVersionId || 0,
            "AppointmentDate": selectedDate || loadData.AppointmentDate,
            "LastRemark": remarkIssueAllocation || loadData.LastRemark || "",
            "LoginId": userId,
            "SubStatusId": loadData.SubstatusId || 0,
            "IsTaskCompleted": 0,
            "EstimatedTime": Number(estimatedTime) || 0,
            "ActivityTypeId": activity || 0,
            "ClientId": loadData.ClientId || "",
            "ProjectId": loadData.ProjectId || "",
            "AllocationReasonId": allocationReason || "",
            "DeliveryTime": 0
        };
        URLS.saveIssueAllocationData(payload)
            .then((response) => {
                if (response.status === 200) {
                    setRemarkIssueAllocation("");
                    setActivity("");
                    setEstimatedTime("");
                    setAllocationReason("");
                    URLS.getIssueAllocationHistory(loadData.Id)
                        .then((response) => {
                            setIssueAllocationHistoryData(response.data.IssueAllocationHistory || [])
                            URLS.showPreviousServices(loadData.Id)
                                .then((response) => {
                                    setShowPreviousServiceData(response.data.PreviousServices)
                                })
                                .catch(error => {
                                    // On error
                                    console.log(" Error ");
                                });
                        })
                        .catch(error => {
                            // On error
                            console.log(" Error ");
                        });
                    URLS.contactDetails({ IssueId: loadData.Id })
                        .then((response) => {
                            setContactData(response.data || [])
                        })
                        .catch(error => {
                            // On error
                            console.log(" Error ");
                        });
                }

                enqueueSnackbar("Issue allocation saved successfully.", { variant: "success" });

            })
            .catch(error => {
                enqueueSnackbar("Record not saved.", { variant: "error" });

                // On error
                console.log(" Error ");
            });
    }

    const handleSaveAllocationClick = () => {
        if (validateIssueAllocation()) {
            setOpenModalForSaveAllocation(true);
        }
    };


    const handleSaveAllocationConfirm = (value) => {
        if (value) {
            handleIssueAllocationSave();
        }
        setOpenModalForSaveAllocation(false);
    };
    // service entry page
    const handleServiceDate = (newValue) => {
        setServiceDate(newValue);

    };
    const handleContactPerson = (newValue) => {
        setContactPerson(newValue?.id || "");
        if (newValue?.id) {
            URLS.getExecutiveContact({ "ExecutiveId": newValue?.id })
                .then((response) => {
                    setContactDetails(response.data[0].PhoneNo || []);
                })
                .catch(error => {
                    // On error
                    console.log(" Error ");
                });
        } else {
            setContactDetails("")
        }


    };
    const handleContactDetails = (e) => {
        setContactDetails(e.target.value)
    };
    const handleServiceType = (newValue) => {
        setServiceType(newValue);
    };
    const handleServiceEntryRemark = (e) => {
        setServiceEntryRemark(e.target.value)
    };
    const handelActivityOpenClick = () => {
        setActivityOpenModal(true);
    };
    const handelActivityCancelClick = () => {
        setActivityOpenModal(false);
    };

    const handleAddNewEntry = () => {
        const newEntry = {
            fromTime: '',
            toTime: '',
            startMin: '',
            minute: '',
            serviceActivity: '',
            serviceRemark: '',
            isShowToClient: false,
            // Add any other fields your object needs
        };

        setServiceEntries((prevEntries) => {
            const updatedEntries = [...prevEntries, newEntry];
            setExpandedAccordion(updatedEntries.length - 1); // open the newly added one
            return updatedEntries;
        });
    };
    const handleDeleteEntry = (indexToRemove) => {
        setServiceEntries((prevEntries) => {
            const updatedEntries = prevEntries.filter((_, i) => i !== indexToRemove);
            return updatedEntries;
        });

        setExpandedAccordion((prevExpanded) => {
            if (prevExpanded === indexToRemove) return null; // if deleted one is open, close all
            if (prevExpanded > indexToRemove) return prevExpanded - 1; // adjust index
            return prevExpanded;
        });
    };

    const handleDeleteServiceConfirm = (confirm) => {
        if (confirm && deleteIndex !== null) {
            handleDeleteEntry(deleteIndex);
        }
        setDeleteIndex(null);
        setOpenModalForDeleteService(false);
    };

    const handleInputChange = (index, field, value) => {
        const newEntries = [...ServiceEntries];

        // Allow only numbers and ':'
        value = value.replace(/[^0-9:]/g, "");

        // Prevent starting with ':'
        if (value.startsWith(":")) {
            return;
        }

        // Allow free typing but restrict length
        if (value.length > 5) return;

        newEntries[index][field] = value;
        newEntries[index][`${field}Error`] = ""; // Clear error while typing

        setServiceEntries(newEntries);
    };

    const handleBlur = (index, field) => {
        const newEntries = [...ServiceEntries];
        let value = newEntries[index][field];

        // Auto-format when user leaves the field
        if (/^\d:\d{2}$/.test(value)) {
            value = `0${value}`; // Convert "4:30" to "04:30"
        } else if (/^\d$/.test(value)) {
            value = `0${value}:00`; // Convert "4" to "04:00"
        } else if (/^\d{2}$/.test(value)) {
            value += ":00"; // Convert "10" to "10:00"
        } else if (/^\d{2}:$/.test(value)) {
            newEntries[index][`${field}Error`] = "Invalid Time Format";
            setServiceEntries(newEntries);
            return;
        }

        // Validate final HH:mm format
        const isValidTime = /^(?:[01]?\d|2[0-3]):[0-5]\d$/.test(value);
        if (!isValidTime) {
            newEntries[index][`${field}Error`] = "Invalid Time Format";
        } else {
            newEntries[index][`${field}Error`] = "";
        }

        newEntries[index][field] = value;
        setServiceEntries(newEntries);
    };

    const handleServiceActivity = (index, value) => {
        const newEntries = [...ServiceEntries];
        newEntries[index].serviceActivity = value; // Update the correct entry
        setServiceEntries(newEntries); // Update the state
    };
    const handleServiceRemarkChange = (index, event) => {
        const newEntries = [...ServiceEntries];
        newEntries[index].serviceRemark = event.target.value;// Update the correct entry
        setServiceEntries(newEntries);
    };
    const handleSelectFile = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const imagesArray = selectedFiles.map((file) => URL.createObjectURL(file));
        setRequestFile((prevImages) => [...prevImages, ...selectedFiles]);
        event.target.value = ""; // Clear the file input value
        console.log("selectedFiles", selectedFiles);
    };
    const handleCheckbox = (index) => (event) => {
        setServiceEntries(prev =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, isShowToClient: event.target.checked }
                    : item
            )
        );
    };
    const removeFile = (index) => {
        setRequestFile((prevFiles) => prevFiles.filter((_, i) => i !== index)); // Remove file by index
    };
    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);
        setRequestFile((prev) => [...prev, ...droppedFiles]);
    };

    const handleDragOver = (event) => {
        event.preventDefault(); // allows drop
    };

    const handleDrgaDropClick = () => {
        fileInputRef.current.click();
    };
    const downloadUploadedFile = () => {
        URLS.getIssueAttachedFiles(loadData.Id)
            .then((response) => {
                if (response.data?.IsDownloadAvailable === true) {
                    const key = response.data?.FileKeys
                    const encodedKey = encodeURIComponent(key); // Encode special characters
                    // URLS.downloadServiceFile(encodedKey, { responseType: "blob" }) // API call to get the file
                    URLS.downloadIssueFile(encodedKey, { responseType: "blob" }) // API call to get the file
                        .then((response) => {
                            const requestUrl = response.request.responseURL; // Get the actual file URL

                            const link = document.createElement("a");
                            link.href = requestUrl; // Directly use the response URL
                            link.setAttribute("download", key); // Set the filename
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            enqueueSnackbar("File downloaded successfully.", { variant: "success" });

                        })
                        .catch(error => {
                            enqueueSnackbar("File not found.", { variant: "error" });
                        });
                } else {
                    enqueueSnackbar("No file available to download.", { variant: "error" });
                }
            })
            .catch(error => {
                enqueueSnackbar("File not found.", { variant: "error" });
                console.error("Error downloading file:", error);
            });
    };

    const validateServiceEntry = () => {
        if (!serviceDate) {
            enqueueSnackbar("Please select a Service Date.");
            return false;
        }
        const formattedServiceDate = Moment(serviceDate).format('DD-MMM-YYYY');
        const formattedCurrentDate = Moment().format('DD-MMM-YYYY');

        const currentTime = Moment();

        const missingField = ServiceEntries.find(entry => {

            console.log("time>>>>>>>>>>", timeType, entry.fromTime, entry.toTime)
            if (timeType === "from-to" && entry.fromTime && entry.toTime && entry.fromTime > entry.toTime) {
                enqueueSnackbar("Start-time must be smaller then End-time.");
                return true;
            }
            if (timeType === "from-to" && !entry.fromTime) {
                enqueueSnackbar("Please enter From Time.");
                return true;
            }
            if (timeType === "from-to" && !entry.toTime) {
                enqueueSnackbar("Please enter To Time.");
                return true;
            }
            if (timeType === "in-minutes" && !entry.startMin) {
                enqueueSnackbar("Please enter Start Time.");
                return true;
            }
            if (timeType === "in-minutes" && !entry.minute) {
                enqueueSnackbar("Please enter To Time (Minutes).");
                return true;
            }

            if (!entry.serviceActivity) {
                enqueueSnackbar("Please select an Activity Type.");
                return true;
            }
            if (!contactPerson) {
                enqueueSnackbar("Please select a Contact Person.");
                return true;
            }
            if (formattedServiceDate === formattedCurrentDate) {
                if (timeType === "from-to") {
                    const toTime = Moment(entry.toTime, "HH:mm");
                    if (toTime > currentTime) {
                        enqueueSnackbar("Service end time can't be greater than current time.");
                        return true;
                    }
                }
                if (timeType === "in-minutes") {
                    const startTime = Moment(entry.startMin, "HH:mm");
                    const endTime = Moment(entry.startMin, "HH:mm").add(Number(entry.minute), "minutes"); // avoid mutation

                    if (endTime > currentTime) {
                        enqueueSnackbar("Service end time can't be greater than current time.");
                        return true;
                    }
                }

            }
            return false;
        });
        if (missingField) return false;

        return true;
    };

    const saveServiceEntry = () => {
        setIsLoading(true);

        const formData = new FormData();

        for (let i = 0; i < requestFile.length; i += 1) {
            formData.append("files", requestFile[i]);  // Ensure backend expects 'uploadedFile'
        }
        const saveServiceList = ServiceEntries.map((entry) => {
            let startTime = "";

            if (timeType === "from-to" && entry.fromTime) {
                startTime = Moment(entry.fromTime, "HH:mm").format("h:mm A");
            } else if (timeType === "in-minutes" && entry.startMin) {
                startTime = Moment(entry.startMin, "HH:mm").format("h:mm A");
            }

            return {
                IssueId: loadData.Id || "",
                SiteId: loadData.SiteId || null,
                ClientId: loadData.ClientId || "",
                ProjectId: loadData.ProjectVersionId || "",
                ActivityId: entry.serviceActivity || 0,
                StartTime: startTime,
                ToTime: entry.toTime ? Moment(entry.toTime, "HH:mm").format("h:mm A") : "",
                Date: serviceDate ? Moment(serviceDate).format("YYYY-MM-DD") : "",
                ServiceRemark: serviceEntryRemark || "",
                ServiceProvided: entry.serviceRemark || "",  // Add default if missing
                PhoneNo: contactDetails || "",
                ServiceInMinute: entry.minute || 0,
                UserID: userId,
                ServiceTypeId: serviceType || 0,
                Status: loadData.SubstatusId || 0,
                IsClientShow: entry.isShowToClient === true ? 1 : 0,
                IsIssueTrackerDashboardTrue: false,
                ServiceId: loadData?.ServiceId || 0,
                IssueSubstatusId: loadData?.SubstatusId ?? loadData?.IssueSubStatusId ?? 0
            };
        });

        saveServiceList.forEach((service, index) => {
            Object.keys(service).forEach(key => {
                formData.append(`saveservice[${index}][${key}]`, service[key] ?? '');
            });
        });
        URLS.insertUpdateServiceEntry(formData)
            .then((response) => {
                if (response.status === 200) {
                    const newDate = new Date();
                    //   fetchAndSetEndTime(newDate);
                    if (fromEdit) {
                        navigate('/dashboard/service/editservices', { replace: true });
                    }
                    URLS.showPreviousServices(loadData.Id)
                        .then((response) => {
                            setShowPreviousServiceData(response.data.PreviousServices)
                        })
                        .catch(error => {
                            // On error
                            console.log(" Error ");
                        });

                    setServiceEntries(() => [{
                        fromTime: "",
                        toTime: "",
                        startMin: "",
                        minute: "",
                        serviceActivity: "",
                        serviceRemark: "",
                        isShowToClient: false
                    }]);
                    setServiceDate(new Date());
                    const defaultUser = selectedContactPerson.find(
                        (person) => person.id === userId
                    );

                    if (defaultUser) {
                        handleContactPerson(defaultUser); // sets contactPerson & fetches contactDetails
                    } else {
                        setContactPerson(userId || "");
                        setContactDetails(""); // optional if user not found
                    }
                    setServiceType(27 || "");
                    setTimeType("from-to");
                    setRequestFile([]);
                    setServiceEntryRemark("");
                    setIsLoading(false);

                    enqueueSnackbar(response.data?.message || "Service saved successfully!", { variant: "success" });

                }
            })
            .catch((error) => {
                setIsLoading(false);

                enqueueSnackbar(error.response?.data?.message || "Service not saved.", { variant: "error" });
            });
    }
    const handleSaveServiceClick = () => {
        if (validateServiceEntry()) {
            setOpenModalForSaveService(true);
        }
    };

    // Confirm save from popup
    const handleSaveServiceConfirm = (value) => {
        if (value) {
            saveServiceEntry();
        }
        setOpenModalForSaveService(false);
    };

    // show previous service
    const handelShowPreviousOpenClick = () => {
        URLS.showPreviousServices(loadData.Id)
            .then((response) => {
                setShowPreviousServiceData(response.data?.PreviousServices || []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        setShowPreviousServiceOpenModal(true);
    };
    const handelShowPreviousCancelClick = () => {
        setShowPreviousServiceOpenModal(false);
    };
    // issue allocation history
    const handelIssueAllocationHistoryOpenClick = () => {
        URLS.getIssueAllocationHistory(loadData.Id)
            .then((response) => {
                setIssueAllocationHistoryData(response.data?.IssueAllocationHistory || []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        setIssueAllocationHistoryOpenModal(true);
    };
    const handelIssueAllocationHistoryCancelClick = () => {
        setIssueAllocationHistoryOpenModal(false);
    };
    const handleObservationHistoryOpenClick = () => {
        setObservationHistoryModal(true);
        handleClose();
        URLS.getIssueRcaAndObservationData({ IssueId: loadData.Id })
            .then((response) => {
                setObservationEditData(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    };
    const handleObservationHistoryCloseClick = () => {
        setObservationHistoryModal(false);
    };

    const handleClick = (event, cellValues) => {
        event.stopPropagation();

        const row = cellValues.row;
        setSelectedObservationEditData(row);
        if (row.Type?.toLowerCase().trim() === 'observation') {
            // Prefill fields
            setObservationReasonTxt(row.Reason || '');
            setObservationReasonDdl(row.ReasonId || '');
            setObservationSolutionTxt(row.Solution || '');
            setObservationOccurrence(row.Occurrence || '');
            setObservationRecurring(row.IsRecurring ?? true);
            setObservationRcaDate(row.RCADate ? new Date(row.RCADate) : null);

            // Close current modal first
            setObservationHistoryModal(false);
            setObservationHistoryOpenModal(false);
            setTabObservationHistoryModal(false);
            // Fetch data and open edit modal
            URLS.getIssueRcaAndObservationData({ IssueId: row.IssueId })
                .then((response) => {
                    setObservationEditData(response.data);
                    setObservationOpenModal(true); // Open edit modal

                })
                .catch(error => {
                    console.log("Error fetching observation history data:", error);
                });
        }
    };

    const handleTimeTypeChange = (newType) => {
        setTimeType(newType);

        const updatedEntries = ServiceEntries.map(entry => {
            const baseTime = defaultTime || "00:00";

            if (newType === "from-to") {
                return {
                    ...entry,
                    fromTime: baseTime,
                    fromTimeError: "",
                    toTime: "",
                    toTimeError: "",
                    startMin: "",
                    startMinError: "",
                    minute: ""
                };
            }

            if (newType === "in-minutes") {
                return {
                    ...entry,
                    startMin: baseTime,
                    startMinError: "",
                    minute: "",
                    fromTime: "",
                    fromTimeError: "",
                    toTime: "",
                    toTimeError: ""
                };
            }

            return entry;
        });

        setServiceEntries(updatedEntries);
    };


    // Contact
    const handleConatctOpenModal = () => {
        URLS.contactDetails({ IssueId: loadData.Id })
            .then((response) => {
                setContactData(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        setContactOpenModal(true);
    };
    const handleContactCloseModal = () => {
        setContactOpenModal(false);
    };

    const handleServiceReset = () => {
        setServiceDate(new Date());
        const defaultUser = selectedContactPerson.find(
            (person) => person.id === userId
        );

        if (defaultUser) {
            handleContactPerson(defaultUser); // sets contactPerson & fetches contactDetails
        } else {
            setContactPerson(userId || "");
            setContactDetails(""); // optional if user not found
        }
        setServiceType(27 || "");
        setServiceEntryRemark("");
        setTimeType("from-to");
        setRequestFile([]);
        setServiceEntries([
            {
                toTime: "",
                minute: "",
                serviceActivity: "",
                serviceRemark: "",
                isShowToClient: ""
            }
        ]);
    }

    const message = {
        forCancel: 'Do you want to back? ',
    };

    const forCancelConfirm = (value) => {
        if (value) {
            navigate('/dashboard/service/services', { replace: true });
        }
        else {
            setOpenModalCancel(false);
        }
    };
    useEffect(() => {
        URLS.loadStatusDropDown()
            .then((response) => {
                setSelectedSubStatus(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadExecutives()
            .then((response) => {
                setSelectedExecutive(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getServiceEntryProject()
            .then((response) => {
                setSelectedProject(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getActivityDD()
            .then((response) => {
                const data = Array.isArray(response.data) ? response.data : [];
                setSelectedActivity(data);
                setSelectedServiceActivity(data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        // URLS.loadRCAReasonList()
        //    .then((response) => {
        //        setSelectedReasonDdl(response.data);
        //    })
        //    .catch(error => {
        //        // On error
        //        console.log(" Error ");
        //    });
        URLS.getRCAReasonList({ ExecutiveId: userId })
            .then((response) => {
                const reasonList = Array.isArray(response.data) ? response.data : [];
                setSelectedReasonDdl(reasonList);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getActivityDDWithDesciption()
            .then((response) => {
                setActivityTypeServiceData(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getExecutiveDD()
            .then((response) => {
                const data = Array.isArray(response.data) ? response.data : [];
                setSelectedContactPerson(data);
                const defaultPerson = data.find((item) => item.id === userId);
                if (defaultPerson) {
                    handleContactPerson(defaultPerson);
                }
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getServiceTypeDD()
            .then((response) => {
                setSelectedServiceType(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });


        const statusPayload = {
            "IssueId": loadData.Id || 0,
            "SiteId": loadData.SiteId || 0,
            "ClientId": loadData.ClientId || 0
        };
        URLS.loadStatus(statusPayload)
            .then((response) => {
                if (response.status === 200) {
                    setStatusPageData(response.data || []);

                }

                console.log("cellValues", response.data, " response.data", response)
            })

            .catch(error => {
                console.log(" Error ");

            });

        URLS.getAppoinmentDateByIssueId({ IssueId: loadData.Id })
            .then((response) => {
                console.log("response", response)
                if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
                    const appointmentDate = response.data[0]?.AppointmentDate;

                    if (appointmentDate) {
                        const updatedDate = new Date(appointmentDate); // Convert to Date object
                        const formattedDate = Moment(updatedDate).format('DD-MMM-YYYY'); // Format date
                        const formattedTime = Moment(updatedDate).format('hh:mm A'); // Format time
                        const mergedDateTime = `${formattedDate} ${formattedTime}`; // Merge date & time

                        // setAppointmentDateTime(Moment(updatedDate).format('DD-MMM-YYYY')); // Format date
                        // setAppointmentTime(Moment(updatedDate).format('hh:mm A'));
                        setSelectedDate(mergedDateTime);
                    } else {
                        setAppointmentDateTime("Set Appointment"); // Show "Set Appointment" if date is null
                        setAppointmentTime("")
                        setSelectedDate("");
                    }

                    setExecutive(response.data[0]?.IssueOwnedById || ""); // Handle if IssueOwnedById is missing
                }
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getIssueAttachedFiles(loadData.Id)
            .then((response) => {

                if (response.data?.IsDownloadAvailable) {

                    setDisableDownloadBtn(true);

                } else {
                    setDisableDownloadBtn(false);

                }
            })
            .catch(error => {
                console.error("Error downloading file:", error);
            });
        URLS.getIssueAllocationReasonList()
            .then((response) => {
                setSelectedAllocationReason(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getObservationReasonList({ ExecutiveId: userId })
            .then((response) => {
                setSelectedObservationReasonDdl(Array.isArray(response.data) ? response.data : []);
                setEntryObsReasonDdl(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    }, []);


    useEffect(() => {
        setIsObservationSaved(false);
    }, [
        observationReasonTxt,
        observationReasonDdl,
        observationsolutionTxt,
        observationOccurrence,
        observationRecurring,
        observationRcaDate
    ]);

    useEffect(() => {
        if (statusPageData.Remark) {
            setClientRemark(statusPageData.Remark.ClientRemark || "");
            setClientSiteRemark(statusPageData.Remark.ClientSiteRemark || "");
            setSiteRemark(statusPageData.Remark.SiteRemark || "");
        }
        setStatusRemark(statusPageData.IssueRemark || "");
        setSubStatus(statusPageData.SubStatusId || "");
        setIsCheck(statusPageData.InCludeInCallList || false);
    }, [statusPageData]);

    useEffect(() => {
        if (selectedProject.length) {
            setProject(loadData.ProjectVersionId || "");
        }

    }, [selectedProject, loadData.ProjectVersionId]);


    useEffect(() => {
        if (fromEdit && loadData?.StartDate) {

            // Edit service → load date from API
            const startDate = new Date(loadData.StartDate);
            setServiceDate(startDate);

            const fromTime = Moment(loadData.StartDate).format("HH:mm");
            const toTime = Moment(loadData.EndDate).format("HH:mm");

            setServiceEntries([
                {
                    fromTime,
                    toTime,
                    startMin: "",
                    minute: "",
                    serviceActivity: loadData.ActivityId,
                    serviceRemark: loadData?.ServiceProvided || "",
                    isShowToClient: false
                }
            ]);
        } else {
            // Create service → set current date
            setServiceDate(new Date());
        }
    }, [fromEdit, loadData]);

    useEffect(() => {
        if (!serviceDate) return;


        // Skip only first edit load
        if (fromEdit && loadData?.StartDate &&
            new Date(loadData.StartDate).getTime() === serviceDate.getTime()) {
            return;
        }

        fetchAndSetEndTime(serviceDate);

    }, [serviceDate]);


    console.log("serviceDate", serviceDate)
    const oldAptTime = loadData?.AppointmentDate; // Old appointment date
    const newAptmtTime = `${appointmentDateTime} ${appointmentTime}`; // New appointment date + time


    return (
        <Page title="Service Details | tiketic" >

            <ContentStyle>
                <StatusServicePage value={value} handleChangeValue={handleChangeValue} handleShow={handleShow} loadData={loadData}
                    showServiceEntry={showServiceEntry} handleShowServiceEntry={handleShowServiceEntry} handleShowStatusIssue={handleShowStatusIssue}
                    expandedAccordion={expandedAccordion} setExpandedAccordion={setExpandedAccordion} handleStatusReset={handleStatusReset}
                    hnadleIssueAllocationReset={hnadleIssueAllocationReset} fromEdit={fromEdit}
                    // Status page
                    subStatus={subStatus} selectedSubStatus={selectedSubStatus} handleSubStatus={handleSubStatus} openModal={openModal} handleCloseModal={handleCloseModal} clientRemark={clientRemark} handleClientRemark={handleClientRemark} siteRemark={siteRemark}
                    handleSiteRemark={handleSiteRemark} clientSiteRemark={clientSiteRemark} handleClientSiteRemark={handleClientSiteRemark} handelOpenClick={handelOpenClick} openTrcakerDetailsModal={openTrcakerDetailsModal}
                    handeltrackerDetailsOpenClick={handeltrackerDetailsOpenClick} handleCloseTrackerDetailsModal={handleCloseTrackerDetailsModal} trackerDetailsColumn={trackerDetailsColumn} trackerDetailsData={trackerDetailsData}
                    handleDeliveryTime={handleDeliveryTime} deliveryTime={deliveryTime} handelCancelClick={handelCancelClick} handleStatusSave={handleStatusSave} forCancelConfirm={forCancelConfirm} message={message}
                    openModalForCancel={openModalForCancel} handleStatusCheckbox={handleStatusCheckbox} isCheck={isCheck} setOpenModalCancel={setOpenModalCancel} reasonDdl={reasonDdl} selectedReasonDdl={selectedReasonDdl} handleReasonDdl={handleReasonDdl}
                    handelReasonCancelClick={handelReasonCancelClick} handelReasonOpenClick={handelReasonOpenClick} reasonOpenModal={reasonOpenModal} reasonTxt={reasonTxt} handleReason={handleReason} solution={solution} handleSolution={handleSolution}
                    recurring={recurring} handleRecurring={handleRecurring} occurrence={occurrence} handleOccurrence={handleOccurrence} rcaDate={rcaDate} handleRcaDate={handleRcaDate} handleRCAReset={handleRCAReset} handleRCASave={handleRCASave} RecurringDropdown={RecurringDropdown}
                    statusRemark={statusRemark} IsRCA={IsRCA} handleStatusRemarkSave={handleStatusRemarkSave} questionnaireModal={questionnaireModal} handleQuestionnaireOpenClick={handleQuestionnaireOpenClick} handelQuestionnaireCancelClick={handelQuestionnaireCancelClick}
                    questionnaire={questionnaire} handleQuestionnaire={handleQuestionnaire} selectedQuestionnaire={selectedQuestionnaire} questionnaireTxt={questionnaireTxt}
                    oldAptTime={oldAptTime} newAptmtTime={newAptmtTime} allocationReason={allocationReason} selectedAllocationReason={selectedAllocationReason} handleAllocationReason={handleAllocationReason} observationOpenModal={observationOpenModal} handleObservationModal={handleObservationModal}
                    handleObservationCloseModal={handleObservationCloseModal} handleObservationReasonDdl={handleObservationReasonDdl} observationReasonDdl={observationReasonDdl} selectedObservationReasonDdl={selectedObservationReasonDdl} handleObservationReason={handleObservationReason}
                    observationReasonTxt={observationReasonTxt} observationsolutionTxt={observationsolutionTxt} handleObservationSolution={handleObservationSolution} handleObservationRecurring={handleObservationRecurring} observationRecurring={observationRecurring} handleObservationOccurrence={handleObservationOccurrence}
                    observationOccurrence={observationOccurrence} handleObservationRcaDate={handleObservationRcaDate} observationRcaDate={observationRcaDate} handleObservationRCASave={handleObservationRCASave} handleObservationRCAReset={handleObservationRCAReset} handleSaveStatusClick={handleSaveStatusClick} handleSaveStatusConfirm={handleSaveStatusConfirm}
                    openModalForSaveStatus={openModalForSaveStatus} setOpenModalForSaveStatus={setOpenModalForSaveStatus} setOpenModalForSaveAllocation={setOpenModalForSaveAllocation} openModalForSaveAllocation={openModalForSaveAllocation} handleSaveAllocationClick={handleSaveAllocationClick} handleSaveAllocationConfirm={handleSaveAllocationConfirm}
                    // Issue Allocation
                    executive={executive} selectedExecutive={selectedExecutive} handleExecutive={handleExecutive} project={project} selectedProject={selectedProject} handleProject={handleProject}
                    handleAppointmentOpenModal={handleAppointmentOpenModal} handleAppointemntCloseModal={handleAppointemntCloseModal} openAppointmentModal={openAppointmentModal} activity={activity} selectedActivity={selectedActivity} handleActivity={handleActivity}
                    estimatedTime={estimatedTime} handleEstimatedTime={handleEstimatedTime} appointmentDateTime={appointmentDateTime} handleAppointmentDateTime={handleAppointmentDateTime} handleAppointmentSave={handleAppointmentSave} selectedDate={selectedDate} error={error}
                    handleIssueAllocationRemark={handleIssueAllocationRemark} remarkIssueAllocation={remarkIssueAllocation} handleTentativeSupport={handleTentativeSupport} availableSlotsData={availableSlotsData} handleAppointmentTime={handleAppointmentTime} appointmentTime={appointmentTime}
                    availableSlotsDataColumn={availableSlotsDataColumn} showTentativeSupport={showTentativeSupport} handleObservationHistoryOpenClick={handleObservationHistoryOpenClick} handleObservationHistoryCloseClick={handleObservationHistoryCloseClick} observationHistoryModal={observationHistoryModal}
                    observationEditData={observationEditData} observationHistoryColumn={observationHistoryColumn} setPageSize5={setPageSize5} pageSize5={pageSize5} observationRCAHistoryColumn={observationRCAHistoryColumn} setPageSize6={setPageSize6} pageSize6={pageSize6}

                    // Header
                    handleTabObservationHistoryModal={handleTabObservationHistoryModal} tabObservationHistoryModal={tabObservationHistoryModal} handleTabObservationHistoryCloseModal={handleTabObservationHistoryCloseModal}

                    // Service Entry Page
                    handleServiceDate={handleServiceDate} serviceDate={serviceDate} handleContactPerson={handleContactPerson} contactPerson={contactPerson} selectedContactPerson={selectedContactPerson} contactDetails={contactDetails} handleContactDetails={handleContactDetails}
                    handleServiceType={handleServiceType} serviceType={serviceType} selectedServiceType={selectedServiceType} timeType={timeType} setTimeType={setTimeType} selectedServiceActivity={selectedServiceActivity} handleServiceActivity={handleServiceActivity} handleServiceRemarkChange={handleServiceRemarkChange}
                    ServiceEntries={ServiceEntries} handleInputChange={handleInputChange} handleAddNewEntry={handleAddNewEntry} serviceEntryRemark={serviceEntryRemark} handleServiceEntryRemark={handleServiceEntryRemark} activityTypeModal={activityTypeModal}
                    handelActivityOpenClick={handelActivityOpenClick} handelActivityCancelClick={handelActivityCancelClick} activityTypeService={activityTypeService} activityTypeServiceData={activityTypeServiceData} handelShowPreviousOpenClick={handelShowPreviousOpenClick}
                    handelShowPreviousCancelClick={handelShowPreviousCancelClick} showPreviousServiceModal={showPreviousServiceModal} showPreviousServiceData={showPreviousServiceData} showPreviousServiceColumn={showPreviousServiceColumn} issueAllocationHistoryColumn={issueAllocationHistoryColumn}
                    handelIssueAllocationHistoryOpenClick={handelIssueAllocationHistoryOpenClick} handelIssueAllocationHistoryCancelClick={handelIssueAllocationHistoryCancelClick} issueAllocationHistoryData={issueAllocationHistoryData} issueAllocationHistoryOpenModal={issueAllocationHistoryOpenModal}
                    saveServiceEntry={saveServiceEntry} handleSelectFile={handleSelectFile} requestFile={requestFile} removeFile={removeFile} downloadUploadedFile={downloadUploadedFile} contactColumn={contactColumn} contactData={contactData} contactOpenModal={contactOpenModal} handleConatctOpenModal={handleConatctOpenModal} handleDrop={handleDrop} handleDragOver={handleDragOver} handleDrgaDropClick={handleDrgaDropClick}
                    handleIssueAllocationSave={handleIssueAllocationSave} disableDownloadBtn={disableDownloadBtn}
                    handleContactCloseModal={handleContactCloseModal} handleBlur={handleBlur} pageSize={pageSize} setPageSize={setPageSize} pageSize1={pageSize1} setPageSize1={setPageSize1} pageSize2={pageSize2} setPageSize2={setPageSize2} pageSize3={pageSize3} setPageSize3={setPageSize3}
                    pageSize4={pageSize4} setPageSize4={setPageSize4} handleTimeTypeChange={handleTimeTypeChange} handleDeleteEntry={handleDeleteEntry} handleServiceReset={handleServiceReset}
                    handleSaveServiceClick={handleSaveServiceClick} handleSaveServiceConfirm={handleSaveServiceConfirm} openModalForSaveService={openModalForSaveService} setOpenModalForSaveService={setOpenModalForSaveService} handleDeleteServiceConfirm={handleDeleteServiceConfirm} setOpenModalForDeleteService={setOpenModalForDeleteService} openModalForDeleteService={openModalForDeleteService} deleteIndex={deleteIndex} setDeleteIndex={setDeleteIndex} open={open} handleObservationClick={handleObservationClick} handleAddNew={handleAddNew}
                    handleAddNewCloseModal={handleAddNewCloseModal} handleHistory={handleHistory} handleHistoryClick={handleHistoryClick} handleClose={handleClose} anchorEl={anchorEl} observationHistoryOpenModal={observationHistoryOpenModal} observationAddModal={observationAddModal} handleObsEntryDate={handleObsEntryDate} handleObsEntrySolution={handleObsEntrySolution} handleObsEntryOccurrence={handleObsEntryOccurrence} handleObsEntryReasonTxt={handleObsEntryReasonTxt} handleObsEntryRecurring={handleObsEntryRecurring} handleObsEntryReasonDdl={handleObsEntryReasonDdl} entryObsDate={entryObsDate} entryObsReason={entryObsReason} entryObsReasonDdl={entryObsReasonDdl} entryObsReasonTxt={entryObsReasonTxt} entryObsSolutionTxt={entryObsSolutionTxt} entryObsOccurrence={entryObsOccurrence} entryObsRecurring={entryObsRecurring} handleObsEntryReset={handleObsEntryReset} handleObsEntrySave={handleObsEntrySave} entryObsEditData={entryObsEditData} obsEntryHistoryColumn={obsEntryHistoryColumn} isShowToClient={isShowToClient} handleCheckbox={handleCheckbox} isLoading={isLoading}

                />
            </ContentStyle>


        </Page>
    );
}

